import {TOWNS_SET_ALL, TOWNS_SET_TO, APP_CLEAR} from '../constants/actionTypes';

const initialState ={
  allTowns: [],
  toTowns: [],
  fromArr: [],
  fromTown: '',
  toTown: '',
};

const townsReducer = (state = initialState, action) => {
  let defTown=''
  switch (action.type) {
    case TOWNS_SET_ALL:
      if (action.towns.length>0)
        defTown=action.towns[0]
      return {
        ...state,
        allTowns: action.towns,
        fromTown: defTown,
        toTowns: action.towns,
        toTown: defTown,
      }
    case TOWNS_SET_TO:
      if (action.towns.length>0)
        defTown=action.towns[0]
      return {
        ...state,
        toTowns: action.towns,
        toTown: defTown,
        //fromArr[]
      }
    case APP_CLEAR:
      return {
        ...state,
        ...initialState
      }
    default:
      return state;
   }
};

export default townsReducer;


// WEBPACK FOOTER //
// ./src/reducers/townsReducer.js